import React, { useEffect,useState } from 'react';
import Slider from "react-slick";
import profileDefault from '../images/profile.gif';
import axios from 'axios';
 
const Testimonial = () => {

     const [gettestimonial, setGetTestimonial] = useState([]);
     const [loading, setLoading] = useState(true);

    const fetchTestimonial = async () => {
        setLoading(true)
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/getTestimonial`,
          
            );
            if (response.data.status === 'success') {
      
      //alert(JSON.stringify(response.data.data));
      setGetTestimonial(response.data.data); // Set the property list
                setLoading(false)
            } else {
              setGetTestimonial([]);
                setLoading(false)
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setGetTestimonial([]);
            setLoading(false)
        }
      };

      const PrevArrow = (props) => {
        const { className, onClick } = props;
        return (
          <button
            className={`custom-arrow custom-prev`}
            onClick={onClick}
          >
            {"<"}
          </button>
        );
      };
    
      const NextArrow = (props) => {
        const { className, onClick } = props;
        return (
          <button
            className={`custom-arrow custom-next`}
            onClick={onClick}
          >
            {">"}
          </button>
        );
      };
     // testimonial
  const testimonial = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    pauseOnHover: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrows: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          dots: true,
          arrows: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          arrows: false
        }
      }
    ]
  };
  

  useEffect(()=>{
    fetchTestimonial();
  },[])
  return (
    <div>

            <section className="testimonials-section sectiontopgap">
              <div className="container">
      
                <div className="sectiontitle">
      
                  <div className="titleunderline" data-aos='fade-right'>
                    <svg width="64" height="3" viewBox="0 0 64 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M2 1.5H62" stroke="#F68633" stroke-width="3" stroke-linecap="round" />
                    </svg>
                  </div>
                  <h1>What Our Valuable Clients Say</h1>
                </div>
      
                <div className='content'>
                  <Slider {...testimonial}>
      
                  {gettestimonial?.length > 0 && (
                      gettestimonial?.map((test, index) => (
                    <div className='testi-cover'>
                      <div className='testibox'>
                        <div className='testinoimgbox'>
                        
                          {test.image ? (
                            <img src={process.env.REACT_APP_IMAGE_PATH + "user/"+test.image} alt="DreamSakha"   onError={(e) => {
                              e.target.onerror = null;
                              e.target.style.display = 'none';
                              e.target.nextSibling.style.display = 'flex';
                            }}/>
                          ) : null}
                          <div className='testmonialFirstLetterHome' style={{ display: test?.image ? 'none' : 'flex' }}>
                            {test?.name ? test.name.split(" ").map(word => word.charAt(0).toUpperCase()).join(""): ""}
                          </div>
                                    
                        </div>
                        {/* <div className='testimgbox'>
                          <img src={process.env.REACT_APP_IMAGE_PATH + "user/"+test.image} alt="DreamSakha" className='img-fluid' onError={(e) => { e.target.onerror = null; e.target.src = profileDefault; }}/>
                        </div> */}
                        <div className='testiInnerBox'>
                          <div className='testidata' style={{ paddingTop: '-25%' }}>
                            <div className='quotemark'>
                              <svg width="120" height="121" viewBox="0 0 144 145" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_3526_3024)">
                                  <path d="M27.498 104.425C21.318 97.8615 18 90.4995 18 78.5655C18 57.5655 32.742 38.7435 54.18 29.4375L59.538 37.7055C39.528 48.5295 35.616 62.5755 34.056 71.4315C37.278 69.7635 41.496 69.1815 45.63 69.5655C56.454 70.5675 64.986 79.4535 64.986 90.4995C64.986 96.0691 62.7735 101.41 58.8352 105.349C54.897 109.287 49.5555 111.5 43.986 111.5C37.548 111.5 31.392 108.56 27.498 104.425ZM87.498 104.425C81.318 97.8615 78 90.4995 78 78.5655C78 57.5655 92.742 38.7435 114.18 29.4375L119.538 37.7055C99.528 48.5295 95.616 62.5755 94.056 71.4315C97.278 69.7635 101.496 69.1815 105.63 69.5655C116.454 70.5675 124.986 79.4535 124.986 90.4995C124.986 96.0691 122.774 101.41 118.835 105.349C114.897 109.287 109.556 111.5 103.986 111.5C97.548 111.5 91.392 108.56 87.498 104.425Z" fill="#E4E4E4" />
                                </g>
                                <defs>
                                  <clipPath id="clip0_3526_3024">
                                    <rect width="144" height="144" fill="white" transform="translate(0 0.5)" />
                                  </clipPath>
                                </defs>
                              </svg>
                            </div>
                            <p>{test?.description}</p>
                          
                            <p className='testi-name'>
                              <h4>{test?.name}</h4>
                            </p>
                            <div className='testi-rating'>
                            {[...Array(5)].map((_, index) => {
                              const rating = test?.rating;
                                const isFilled = index < rating;
                                return (
                                  <svg
                                    key={index}
                                    width="22"
                                    height="21"
                                    viewBox="0 0 16 17"
                                    fill={isFilled ? "rgb(255, 213, 0)" : "none"}
                                    xmlns="http://www.w3.org/2000/svg"
                                    stroke="rgb(255, 213, 0)"
                                  >
                                    <path
                                      d="M7.51338 3.43946C7.66772 3.09321 7.74492 2.92008 7.85238 2.86677C7.94572 2.82045 8.05532 2.82045 8.14865 2.86677C8.25612 2.92008 8.33332 3.09321 8.48765 3.43946L9.71698 6.19742C9.76265 6.29978 9.78545 6.35096 9.82078 6.39015C9.85198 6.42483 9.89018 6.45257 9.93278 6.47156C9.98098 6.49302 10.0367 6.49891 10.1482 6.51067L13.151 6.8276C13.528 6.86739 13.7165 6.88728 13.8004 6.97301C13.8733 7.04747 13.9072 7.15174 13.892 7.25483C13.8745 7.3735 13.7337 7.50036 13.4521 7.75416L11.209 9.77563C11.1258 9.85063 11.0841 9.88817 11.0578 9.93383C11.0345 9.9743 11.0199 10.0192 11.015 10.0656C11.0095 10.118 11.0211 10.1728 11.0443 10.2825L11.6709 13.2363C11.7495 13.6072 11.7889 13.7926 11.7333 13.8988C11.6849 13.9912 11.5963 14.0556 11.4935 14.073C11.3753 14.093 11.2111 13.9984 10.8827 13.809L8.26698 12.3003C8.16992 12.2443 8.12138 12.2164 8.06978 12.2054C8.02412 12.1957 7.97692 12.1957 7.93125 12.2054C7.87965 12.2164 7.83112 12.2443 7.73405 12.3003L5.1184 13.809C4.79001 13.9984 4.62582 14.093 4.50754 14.073C4.4048 14.0556 4.31611 13.9912 4.26782 13.8988C4.21222 13.7926 4.25155 13.6072 4.33021 13.2363L4.95672 10.2825C4.97997 10.1728 4.9916 10.118 4.98608 10.0656C4.98119 10.0192 4.96661 9.9743 4.94328 9.93383C4.91691 9.88817 4.87528 9.85063 4.79204 9.77563L2.54896 7.75416C2.26735 7.50036 2.12654 7.3735 2.10904 7.25483C2.09384 7.15174 2.12771 7.04747 2.2006 6.97301C2.28452 6.88728 2.47302 6.86739 2.85002 6.8276L5.85288 6.51067C5.96434 6.49891 6.02006 6.49302 6.06824 6.47156C6.11088 6.45257 6.14905 6.42483 6.18029 6.39015C6.21559 6.35096 6.2384 6.29978 6.28404 6.19742L7.51338 3.43946Z"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                      ))
                    )}
                    
                  </Slider>
                </div>
              </div>
            </section>




       {/* <section className="testimonials-section sectiontopgap">
        <div className="container">

          <div className="sectiontitle">

            <div className="titleunderline" data-aos='fade-right'>
              <svg width="64" height="3" viewBox="0 0 64 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 1.5H62" stroke="#F68633" stroke-width="3" stroke-linecap="round" />
              </svg>
            </div>
            <h1 data-aos='fade-left'>What Our Valuable Clients Say</h1>
          </div>

          <div className='content'>
            <Slider {...testimonial}>

            {gettestimonial?.length > 0 && (
                gettestimonial?.map((test, index) => (
              <div className='testi-cover'>
                <div className='testibox'>

                  <div className='testimgbox'>
                    <img src={process.env.REACT_APP_IMAGE_PATH + "user/"+test.image} alt="DreamSakha" className='img-fluid' onError={(e) => { e.target.onerror = null; e.target.src = profileDefault; }}/>
                  </div>
                  <div className='testiInnerBox'>
                    <div className='testidata' style={{ paddingTop: '-25%' }}>
                      <div style={{ marginLeft: '-20%' }}>
                        <svg width="144" height="145" viewBox="0 0 144 145" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clipPath="url(#clip0_3526_3024)">
                            <path d="M27.498 104.425C21.318 97.8615 18 90.4995 18 78.5655C18 57.5655 32.742 38.7435 54.18 29.4375L59.538 37.7055C39.528 48.5295 35.616 62.5755 34.056 71.4315C37.278 69.7635 41.496 69.1815 45.63 69.5655C56.454 70.5675 64.986 79.4535 64.986 90.4995C64.986 96.0691 62.7735 101.41 58.8352 105.349C54.897 109.287 49.5555 111.5 43.986 111.5C37.548 111.5 31.392 108.56 27.498 104.425ZM87.498 104.425C81.318 97.8615 78 90.4995 78 78.5655C78 57.5655 92.742 38.7435 114.18 29.4375L119.538 37.7055C99.528 48.5295 95.616 62.5755 94.056 71.4315C97.278 69.7635 101.496 69.1815 105.63 69.5655C116.454 70.5675 124.986 79.4535 124.986 90.4995C124.986 96.0691 122.774 101.41 118.835 105.349C114.897 109.287 109.556 111.5 103.986 111.5C97.548 111.5 91.392 108.56 87.498 104.425Z" fill="#E4E4E4" />
                          </g>
                          <defs>
                            <clipPath id="clip0_3526_3024">
                              <rect width="144" height="144" fill="white" transform="translate(0 0.5)" />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <p>{test?.description}</p>
                    </div>
                    <p className='testi-name'>
                      <h4>{test?.name}</h4>
                    </p>
                    <div className='testi-rating'>
                    {[...Array(5)].map((_, index) => {
                      const rating = test?.rating;
                        const isFilled = index < rating;
                        return (
                          <svg
                            key={index}
                            width="16"
                            height="17"
                            viewBox="0 0 16 17"
                            fill={isFilled ? "rgb(255, 213, 0)" : "none"}
                            xmlns="http://www.w3.org/2000/svg"
                            stroke="rgb(255, 213, 0)"
                          >
                            <path
                              d="M7.51338 3.43946C7.66772 3.09321 7.74492 2.92008 7.85238 2.86677C7.94572 2.82045 8.05532 2.82045 8.14865 2.86677C8.25612 2.92008 8.33332 3.09321 8.48765 3.43946L9.71698 6.19742C9.76265 6.29978 9.78545 6.35096 9.82078 6.39015C9.85198 6.42483 9.89018 6.45257 9.93278 6.47156C9.98098 6.49302 10.0367 6.49891 10.1482 6.51067L13.151 6.8276C13.528 6.86739 13.7165 6.88728 13.8004 6.97301C13.8733 7.04747 13.9072 7.15174 13.892 7.25483C13.8745 7.3735 13.7337 7.50036 13.4521 7.75416L11.209 9.77563C11.1258 9.85063 11.0841 9.88817 11.0578 9.93383C11.0345 9.9743 11.0199 10.0192 11.015 10.0656C11.0095 10.118 11.0211 10.1728 11.0443 10.2825L11.6709 13.2363C11.7495 13.6072 11.7889 13.7926 11.7333 13.8988C11.6849 13.9912 11.5963 14.0556 11.4935 14.073C11.3753 14.093 11.2111 13.9984 10.8827 13.809L8.26698 12.3003C8.16992 12.2443 8.12138 12.2164 8.06978 12.2054C8.02412 12.1957 7.97692 12.1957 7.93125 12.2054C7.87965 12.2164 7.83112 12.2443 7.73405 12.3003L5.1184 13.809C4.79001 13.9984 4.62582 14.093 4.50754 14.073C4.4048 14.0556 4.31611 13.9912 4.26782 13.8988C4.21222 13.7926 4.25155 13.6072 4.33021 13.2363L4.95672 10.2825C4.97997 10.1728 4.9916 10.118 4.98608 10.0656C4.98119 10.0192 4.96661 9.9743 4.94328 9.93383C4.91691 9.88817 4.87528 9.85063 4.79204 9.77563L2.54896 7.75416C2.26735 7.50036 2.12654 7.3735 2.10904 7.25483C2.09384 7.15174 2.12771 7.04747 2.2006 6.97301C2.28452 6.88728 2.47302 6.86739 2.85002 6.8276L5.85288 6.51067C5.96434 6.49891 6.02006 6.49302 6.06824 6.47156C6.11088 6.45257 6.14905 6.42483 6.18029 6.39015C6.21559 6.35096 6.2384 6.29978 6.28404 6.19742L7.51338 3.43946Z"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
                ))
              )}
            </Slider>
          </div>
        </div>
      </section> */}
    </div>
  )
}

export default Testimonial
